// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2hEr7","dragIcon":"Choice_dragIcon__333FG","left":"Choice_left__2TBc-","input":"Choice_input__3FBw3"};